import DereferenceError from "./DereferenceError.js";
class MaximumDereferenceDepthError extends DereferenceError {}
export default MaximumDereferenceDepthError;